import {parseSearch} from "../../src/app/utils/request_response_utils/parse_search";

export const getClientRouteState = (location: {pathname: string; search: string; hash: string; state: unknown}) => ({
    pathname: location.pathname,
    query: parseSearch(location.search),
    hash: location.hash,
    url: location.pathname + location.search + location.hash,
    state: location.state // state is available client side after history `pushState` or `replace` was used
});
